import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { LookupService } from '../../services/lookup.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FormService } from '../../services/form.service';
import { BaseFormComponent } from '../../models/base/base-form.component';
import { ModalLeftNavItem } from '../../models/modal-left-nav.model';
import { FormHelperService } from '../../services/form-helper.service';

@Component({
  selector: 'quote-form',
  templateUrl: './quote-form.component.html',
  providers: [
    LookupService,
    FormService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteFormComponent extends BaseFormComponent implements OnInit {
  @Input() id: string = null;
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSaveComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLoad: EventEmitter<any> = new EventEmitter<any>();

  metadata: any = {};
  lookups: any = {}
  selectedContacts = [];

  serverError: string = null;
  errors = [];
  title: string = 'Quote';

  leftNav: ModalLeftNavItem[] = [];
  navKeys: any = {};
  leftNavSelected: string = 'customer';
  leftNavSelectedIndex: number = 0;

  newNotes = [];

  buttons: any[] = [];

  constructor(
    private lookupService: LookupService,
    private formService: FormService,
    private router: Router,
    private messageService: MessageService,
    private ref: ChangeDetectorRef,
    private fh: FormHelperService) {
    super();
    this.entityName = 'quote'

  }

  ngOnInit() {
    this.isAdding = this.id == null || this.id == '';
    this.isEditing = this.id != null && this.id != '';
    this.isLoading = true;

    this.loadLookup('stateCode');
    this.loadLookup('phoneType');
    this.loadLookup('operability');
    this.loadLookup('yesNoNa');
    this.loadLookup('yesNo');
    this.loadLookup('yesNoPartial');
    this.loadLookup('yesNoNull');
    this.loadLookup('yesNoNaNull');
    this.loadLookup('openEnclosed');

    this.load();
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  loadForm() {
    let m = this.model;

    if (m == null)
      m = { id: 0, order: null };

    this.form = new FormGroup({}, []);

    this.form.addControl('id', new FormControl(m.id));
    this.form.addControl('customerFirstName', new FormControl(m.customerFirstName, [Validators.required]));
    this.form.addControl('customerLastName', new FormControl(m.customerLastName, [Validators.required]));
    this.form.addControl('customerEmail', new FormControl(m.customerEmail, [Validators.required]));
    this.form.addControl('customerBusinessName', new FormControl(m.customerBusinessName));
    this.form.addControl('customerBusinessHours', new FormControl(m.customerBusinessHours));
    this.form.addControl('customerAddress1', new FormControl(m.customerAddress1));
    this.form.addControl('customerCity', new FormControl(m.customerCity));
    this.form.addControl('customerStateCode', new FormControl(m.customerStateCode));
    this.form.addControl('customerZip', new FormControl(m.customerZip, this.getValidators(5, 5)));
    this.form.addControl('customerPhoneType', new FormControl(m.customerPhoneType));
    this.form.addControl('customerPhone', new FormControl(m.customerPhone, this.getValidators(10, 15)));
    this.form.addControl('customerExpectedPickup', new FormControl(m.customerExpectedPickup));
    this.form.addControl('customerExpectedDelivery', new FormControl(m.customerExpectedDelivery));
    this.form.addControl('pickupCity', new FormControl(m.pickupCity, [Validators.required]));
    this.form.addControl('pickupStateCode', new FormControl(m.pickupStateCode, [Validators.required]));
    this.form.addControl('deliveryCity', new FormControl(m.deliveryCity, [Validators.required]));
    this.form.addControl('deliveryStateCode', new FormControl(m.deliveryStateCode, [Validators.required]));
    this.form.addControl('price', new FormControl(m.price, [Validators.required]));
    this.form.addControl('specialInstructions', new FormControl(m.specialInstructions));
    this.form.addControl('openEnclosed', new FormControl(m.openEnclosed, [Validators.required]));

    if (m.vehicles != null && m.vehicles.length > 0) {
      let vehicleForms = [];
      this.model.vehicles.forEach(r => {
        vehicleForms.push(this.fh.getQuoteVehicleForm(r))
      });
      this.form.addControl('vehicles', new FormArray(vehicleForms));
    } else {
      this.form.addControl('vehicles', new FormArray([this.fh.getQuoteVehicleForm()]));
    }

    this.loadNav();

    setTimeout(() => {
      this.isLoading = false;
      this.ref.markForCheck();
    }, 100);

  }

  load() {
    if (this.isAdding) {
      this.formService.getEditNew(this.entityName)
        .subscribe(r => {
          this.metadata = r.body;
          this.loadForm();
          this.ref.markForCheck();
          this.isLoading = false;
        });
    }
    else if (this.isEditing) {
      this.formService.getEdit(this.entityName, this.id)
        .subscribe(r => {
          this.model = r.body;
          this.metadata = this.model.metadata;
          this.loadForm();
          this.isLoading = false;

          this.onLoad.emit(this.model);
        });
    }
  }

  loadNav() {
    this.navKeys = {};
    this.leftNav = [];
    let nav;

    nav = new ModalLeftNavItem();
    nav.key = 'customer';
    nav.label = 'Customer';
    nav.order = 10;
    nav.count = 0;
    this.navKeys['customer'] = [];
    this.navKeys.customer.push('customerFirstName');
    this.navKeys.customer.push('customerLastName');
    this.navKeys.customer.push('customerBusinessName');
    this.navKeys.customer.push('customerBusinessHours');
    this.navKeys.customer.push('customerEmail');
    this.navKeys.customer.push('customerAddress1');
    this.navKeys.customer.push('customerStateCode');
    this.navKeys.customer.push('customerCity');
    this.navKeys.customer.push('customerZip');
    this.navKeys.customer.push('customerPhoneType');
    this.navKeys.customer.push('customerPhone');

    this.leftNav.push(nav);


      nav = new ModalLeftNavItem();
      nav.key = 'vehicles';
      nav.label = 'Vehicles';
      nav.order = 20;
      nav.count = 0;
      if (this.form.contains('vehicles') && (this.form.get('vehicles') as FormArray).length > 0)
        nav.count = (this.form.get('vehicles') as FormArray).length;
      this.navKeys['vehicles'] = [];
      this.navKeys.vehicles.push('openEnclosed');
      this.navKeys.vehicles.push('vehicles');

      this.leftNav.push(nav);



      nav = new ModalLeftNavItem();
      nav.key = 'pickup';
      nav.label = 'Pickup';
      nav.order = 30;
      nav.count = 0;
      this.navKeys['pickup'] = [];
      this.navKeys.pickup.push('customerExpectedPickup');
      this.navKeys.pickup.push('pickupStateCode');
      this.navKeys.pickup.push('pickupCity');

      this.leftNav.push(nav);


      nav = new ModalLeftNavItem();
      nav.key = 'delivery';
      nav.label = 'Delivery';
      nav.order = 40;
      nav.count = 0;
      this.navKeys['delivery'] = [];
      this.navKeys.delivery.push('customerExpectedDelivery');
      this.navKeys.delivery.push('deliveryStateCode');
      this.navKeys.delivery.push('deliveryCity');

      this.leftNav.push(nav);


      nav = new ModalLeftNavItem();
      nav.key = 'billing';
      nav.label = 'Billing';
      nav.order = 50;
      nav.count = 0;
      this.navKeys['billing'] = [];
      this.navKeys.billing.push('price');

      this.leftNav.push(nav);


      nav = new ModalLeftNavItem();
      nav.key = 'notes';
      nav.label = 'Notes';
      nav.order = 1000;
      nav.count = 0;
      this.navKeys['notes'] = [];

      this.leftNav.push(nav);



    this.leftNav = this.leftNav.sort((a, b) => {
      if (a.order > b.order) return 1;
      if (a.order < b.order) return -1;
      return 0;
    });

    this.leftNav = this.leftNav.slice();
  }

  get navIndex(): number {
    return this.leftNav.findIndex(r => r.key == this.leftNavSelected);
  }

  get getButtons(): any[] {

    if (this.buttons.length > 0)
      return this.buttons;

    let buttons = [];

    this.kebob = [];

    if (this.isAdding) {
      buttons.push({ label: 'Create Quote', key: 'save', validate: true });
    } else {
      buttons.push({ label: 'Save', key: 'save', validate: true });
      buttons.push({ label: 'Convert to Order', key: 'convert', validate: true });
    }



    this.buttons = buttons;
    return this.buttons;
  }

  countChange(key: string, count: number) {
    let l = this.leftNav.find(f => f.key == key);
    if (l != null) {
      l.count = count;
    }
  }

  get formInvalid(): boolean {
    return this.isLoading || !this.form.valid || this.errors.length > 0;
  }

  clickLeftNav(n: ModalLeftNavItem) {
    this.validateSection(this.leftNavSelected);
    this.leftNavSelected = n.key
    this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);
  }

  clickNext() {
    this.validateSection(this.leftNavSelected);
    let n = this.leftNav.findIndex(r => r.key == this.leftNavSelected);
    if (n < (this.leftNav.length - 1)) {
      let x = this.leftNav[n + 1];
      this.leftNavSelected = x.key;
      this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);
    }
  }

  clickPrevious() {
    this.validateSection(this.leftNavSelected);
    let n = this.leftNav.findIndex(r => r.key == this.leftNavSelected);
    if (n > 0) {
      let x = this.leftNav[n - 1];
      this.leftNavSelected = x.key;
      this.leftNav.forEach(n => n.selected = n.key == this.leftNavSelected);
    }
  }

  validateSection(key: string) {
    let issueCount = 0;
    let nav = this.leftNav.find(n => n.key == key);
    if (nav != null) {
      let keys = this.navKeys[key];
      if (keys != null && keys.length > 0) {
        keys.forEach(k => {
          if (this.form.contains(k)) {
            if (this.form.get(k) instanceof FormArray) {
              if ((this.form.get(k) as FormArray).length < 1)
                issueCount++;
              (this.form.get(k) as FormArray).controls.forEach(c => {
                Object.keys((c as FormGroup).controls).forEach(ck => {
                  c.get(ck).markAsTouched();
                });
              });
            } else {
              this.form.get(k).markAsTouched();
            }

            if (this.form.get(k).invalid)
              issueCount++;
          }
        });
      }
      nav.issueCount = issueCount;
      nav.icon = issueCount > 0 ? 'alert' : 'input-selected-green';
    }
  }

  click(key: string) {
    switch (key) {
      case 'save':
        this.save();
        break;
      case 'convert':
        this.form.addControl('convertToOrder', new FormControl(true));
        this.save();
        break;
      default:
        console.warn('Invalid key ' + (key || '') + ' passed to click function.');
        break;
    }
  }

  save() {
    let f = this.form.value;
    if (!this.isLoading) {
      if (this.isAdding) {
        f.notes = this.newNotes;
        this.isLoading = true;
        this.formService.add(this.entityName, f)
          .subscribe(res => {
            if (res != null && !res.isError) {
              this.messageService.add(this.toast(true, res.message))
              this.router.navigate(['/quotes']);
              this.isLoading = false;
              this.onSaveComplete.emit(res.body);
            }
          },
            err => {
              this.ref.markForCheck();
              this.isLoading = false;

              if (err.error.message != null) {
                this.messageService.add(this.toast(false, err.error.message))
                this.serverError = err.error.message;
              } else if (err.status == 500) {
                this.messageService.add(this.toast(false, 'Internal Server Error'))
                this.serverError = 'Internal Server Error';
              }
            })
      }
      else if (this.isEditing) {
        this.isLoading = true;
        this.formService.edit(this.entityName, f)
          .subscribe(res => {
            if (res != null && !res.isError) {

              if (f.convertToOrder === true) {
                this.router.navigate(['/orders'], { queryParams: { show: res.body } });
                this.isLoading = false;
                this.onSaveComplete.emit(res.body);
              } else {
                this.messageService.add(this.toast(true, res.message))
                this.router.navigate(['/quotes']);
                this.isLoading = false;
                this.onSaveComplete.emit(res.body);
              }
            }
          },
            err => {
              this.ref.markForCheck();
              this.isLoading = false;

              if (err.error.message != null) {
                this.messageService.add(this.toast(false, err.error.message))
                this.serverError = err.error.message;
              } else if (err.status == 500) {
                this.messageService.add(this.toast(false, 'Internal Server Error'))
                this.serverError = 'Internal Server Error';
              }
            })
      }
    }
  }

  cancel() {
    this.form = new FormGroup({}, []);
    this.onCancel.emit(null);
  }

  logForm() {
    console.log(this.form);
  }
}
